import { h as __h } from "preact";
/** @import { adminMachineResponse } from "~/backend/validate.js"; */
import { ApiError, authedApiRequest } from "~/lib/api.js";
import { alert } from "~/util/alert.js";
import html from "~/util/html.js";
import Query from "~/util/query.js";
import { confirmModal } from "~/component/ConfirmModal.js";

/**
 * @param {{ orgId: string; groupId: string }} props
 * @param {adminMachineResponse[]} machines
 */
export const removeComputers = async ({
  orgId,
  groupId
}, ...machines) => {
  const res = await confirmModal({
    title: machines.length === 1 ? `Remove ${machines[0]?.name} from this group?` : `Remove ${machines.length} computers from this group?`,
    action: "Remove",
    body: __h("p", {}, "They will stay in the organization, without an assignee.")
  });
  if (!res) return;
  try {
    await authedApiRequest("PUT", `/v2/orgs/${orgId}/machines/unassign`, {
      json: {
        machine_ids: machines.map(machine => machine.id)
      }
    });
    Query.invalidate([`/ui/admin/orgs/${orgId}/machines`], ...machines.map(machine => [`/ui/admin/orgs/${orgId}/machines/${machine.id}`]), [`/v2/orgs/${orgId}/groups`], [`/v2/orgs/${orgId}/groups/${groupId}`]);
    return true;
  } catch (err) {
    alert(ApiError.from(err).message, {
      type: "error"
    });
    return;
  }
};